'use client';

import { useI18n } from '@locales/client';
import { useIsAuth, useUserKycWarning } from '@/shared/providers/user-provider/use-user';
import { useBreakpoints } from '@/shared/hooks/useBreakpoints';

export function useShouldShowKycVerificationBanner() {
  const t = useI18n();
  const { isMobile } = useBreakpoints();
  const isAuth = useIsAuth();
  const kycWarning = useUserKycWarning();

  const kycWarningTitleKey = kycWarning ? `verification.banner.${kycWarning}.title` : null;
  const hasKycWarningTranslation = Boolean(kycWarningTitleKey) && t(kycWarningTitleKey) !== kycWarningTitleKey;

  return Boolean(isMobile && isAuth && kycWarning && hasKycWarningTranslation);
}
